<template>
    <v-flex xs12 :class="[$vuetify.breakpoint.xs ? 'nav-menu--mobile-container' : 'nav-menu-container',
                    this.sidebar ? 'extra-details-menu--active' : '']">
        <div v-if="showNewMemberBannerUI && isMobileSystemMessageVisible"  class="new_member_banner">
               <div class="new_member_banner__content">
                 <span v-html="welcomeBannerText"></span>
               </div>
             </div>
        <v-layout column v-if="isMobileSystemMessageVisible">
            <v-flex
                    xs12
                    pa-2
                    pl-3
                    v-for="message in systemMessages"
                    :data-qe-id="`system_message_${message.id}`"
                    :class="['system-message-mobile', message.allUpperCase ? 'system-message--uppercase' : '']"
                    :style="{color: message.textColor || appCommonConstants.DEFAULT_SYSTEM_TEXT_COLOR,
                            backgroundColor: message.backgroundColor || appCommonConstants.DEFAULT_SYSTEM_BACKGROUND_COLOR}"
                    :key="message.id"
                    v-html="removeTargetBlank(message)">
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-flex xs12 class="nav-menu--mobile-container--bar">
        <i class="extra-details-menu fas fa-chevron-right"
           :class="this.sidebar ? 'extra-details-menu--active__icon' : ''"
           v-if="$vuetify.breakpoint.xs"
           @click="toggleExtraDetails"
           data-qe-id="display-extra-details-section__menu-icon"></i>
        <v-layout class="nav-menu"
                  :class="$vuetify.breakpoint.xs ? 'nav-menu--mobile-view' : ''"
                  row>
            <v-flex
                :key="i"
                :class="['nav-menu__options', isSelectedMenuItem(menu) ? 'nav-menu--active-menu' : '', 'relative-position',
            $vuetify.breakpoint.xs && menu==='businesses' ? 'display-none' : '']"
                v-for="(menu, i) in menuNames">
                <v-menu :content-class="$vuetify.breakpoint.xs ? 'nav-menu__dropdown--mobile' : 'nav-menu__dropdown'"
                        offset-y
                        v-if="getCommunityListByType(menu).length">
                    <div slot="activator" class="nav-menu__item">
                        <v-layout row @click="handleForumsClick(menu)">
                            <v-flex>{{ getRibbonNameByMenu(menu) }}</v-flex>
                                <v-flex v-if="shouldShowDropdownOptions(menu)">
                                <v-icon>fas fa-sort-down</v-icon>
                            </v-flex>
                        </v-layout>
                        </div>
                    <v-list v-if="getCommunityListByType(menu).length && shouldShowDropdownOptions(menu)" class="menu-options inner-scrollbar">
                    <v-list-tile :key="index"
                                v-for="(community,index) in getCommunityListByType(menu)"
                                @click="navigateToSpecificCommunity(menu, community.communityId)"
                                :data-qe-id="`${menu}_${community.name}`"
                                :class="[
                                    isActiveItem(community) ? 'nav-menu--active-item' : '',
                                    isActiveItem(community) && $vuetify.breakpoint.xs ? 'nav-menu--mobile-active-item' : '']">
                        <span :class="isHivebriteRedirectCommunity(community.communityId) && `HB_redirect_community`">{{community.name}}</span>
                    </v-list-tile>
                </v-list>
                </v-menu>
                <div class="nav-menu__item" @click="navigateTo(menu)"
                    @mouseenter="menu === 'home' ? hover = true : null"
                    @mouseleave="menu === 'home' ? hover = false : null" 
                    v-if="!getCommunityListByType(menu).length">
                        <span v-if="menu==='businesses'" class="d-inline-block nav_links--business pr-2">
                            <i class="fas fa-utensils pr-1"></i>
                            <i class="fas fa-bed"></i>
                        </span>
                        <span>
                        <icon-ypo-white v-if="menu==='home'" :height="15" :width="20"
                        :isActive="isActiveMenu(menu)"
                        :hoverState="hover && menu === 'home'"
                        ></icon-ypo-white>
                        </span>
                        <span>{{getRibbonNameByMenu(menu)}}</span>
                </div>
            </v-flex>
        </v-layout>
    </v-flex>
    <v-flex class="sidebar-tabView__cont inner-scrollbar extra-details-menu__result"
            v-if="sidebar && $vuetify.breakpoint.xs">
        <quick-links></quick-links>
        <router-view name="leftSidebar"></router-view>
        <router-view name="rightSidebar"></router-view>
        <PoliciesTerms></PoliciesTerms>
    </v-flex>
    <RequestNewGroup ref="requestNewGroupDialog" :showRequestButton="false"></RequestNewGroup>
  </v-layout>

    </v-flex>
  </template>


  <script>
    import { mapActions, mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import {
        routerNames,
        menuOptions,
        menuDisplayNames,
        capitalize,
        appCommonConstants,
        userRoles,
    } from "../appCommon.constants";
    import { defaultCommunityFilters } from "../CommunityDirectoryPage/communityDirectoryPage.constants";
    import orderBy from "lodash/orderBy";
    import QuickLinks from "@/components/Tools/QuickLinks/QuickLinks";
    import { storeAction } from "../../store/storeActions.constant";
    import PoliciesTerms from "../Tools/QuickLinks/PoliciesAndTerms";
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
    import { getWelcomeBannerText, showNewMemberBanner } from "@/components/MyAccount/myaccount.constants";
    import { myToolsConstants } from "../Tools/mytools.constant";
    import { sendForumMessage } from "@/app.utils";
    import { commonEnvVariables } from "@/commonEnvVariables";
    import IconYpoWhite from "../Icons/IconYpoWhite.vue";
    import { groupConstants } from '../GroupPage/groupConstant';
    import RequestNewGroup from '@/components/GroupPage/RequestNewGroup';

    export default {
        name: "MenuBar",
        created() {
            this.getSystemMessages();
        },
        components: {
            QuickLinks,
            PoliciesTerms,
            IconYpoWhite,
            RequestNewGroup,
        },
        data: () => {
            return {
                appCommonConstants,
                userRoles,
                routerNames,
                menuOptions,
                menuDisplayNames,
                collapsed: false,
                isBusinessVisible: false,
                sidebar: false,
                currentImage: null,
                hover: false,
            };
        },
        props: {
            toggleMenu: {
                type: Boolean,
                required: false,
            },
        },
        methods: {
            ...mapActions({
                getSystemMessages: `notification/${storeAction.getSystemMessages}`,
            }),
            isActiveMenu(menu) {
                return this.$route.name === menu;
            },
            removeTargetBlank(message) {
                const removeTarget = /target=\"_blank\"/;
                return message.body.replace(removeTarget, '');
            },
            shouldShowDropdownOptions(menu) {
                return !((menu.toLowerCase() === myToolsConstants.QUICK_LINKS.Forum.toLowerCase() && this.isMobileAppBrowser));
            },
            navigateTo(page) {
                if (page === myToolsConstants.QUICK_LINKS.Forum.toLowerCase() && this.isMobileAppBrowser) {
                    sendForumMessage();
                } else {
                    this.$router.push(`/${page}`);
                }
            },
            handleForumsClick(menu) {
            if (menu === myToolsConstants.QUICK_LINKS.Forum.toLowerCase() && this.isMobileAppBrowser) {
                sendForumMessage();
                }
            },
            toggleExtraDetails() {
                this.sidebar = !this.sidebar;
            },
            getPrimaryId(itemList) {
                let primaryId = "";
                if (itemList && itemList.length > 0) {
                    primaryId = itemList.find(c => c.isPrimaryCommunity);
                    primaryId = primaryId ? primaryId.communityId : itemList[0].communityId;
                }
                return primaryId;
            },
            getCommunityListByType(menuType) {
                let communitiesList = [];
                if (menuType.toLowerCase() === this.menuOptions.HOME) {
                    return communitiesList;
                }
                if (this.usersCommunitiesList) {
                    communitiesList = this.usersCommunitiesList.filter(o => o.communityType.toLowerCase() === menuType.toLowerCase());
                    communitiesList = orderBy(communitiesList, (a => a.name.toLowerCase()), ["asc"]);
                }
                if (menuType.toLowerCase() === this.menuOptions.CHAMPION) {
                    const champOption = { name: myToolsConstants.BECOME_A_CHAMPION, communityId: myToolsConstants.BECOME_A_CHAMPION_ID };
                    communitiesList.splice(1, 0, champOption);
                }
                if (menuType.toLowerCase() === this.menuOptions.CHAPTER) {
                  if (this.canViewChapterStudioPage) {
                    communitiesList.unshift({ name: myToolsConstants.CHAPTER_STUDIO, communityId: myToolsConstants.CHAPTER_STUDIO_ID });
                  }
                }
                if (menuType.toLowerCase() === this.menuOptions.GROUP) {
                    communitiesList.unshift({ name: myToolsConstants.VIEW_ALL_GROUPS, communityId: myToolsConstants.ALL_GROUPS_COMMUNITY_ID });
                    communitiesList.splice(1, 0, { name: groupConstants.REQUEST_NEW_GROUP, communityId: groupConstants.REQUEST_NEW_GROUP_ID });
                }
                if (menuType.toLowerCase() === this.menuOptions.NETWORK) {
                    const yourNetworksIndex = communitiesList.findIndex(item => item.name === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED);
                    if (yourNetworksIndex !== -1) {
                        const yourNetworksConsolidated = communitiesList.splice(yourNetworksIndex, 1)[0];
                        communitiesList.unshift(yourNetworksConsolidated);
                    }
                    communitiesList.unshift({ name: myToolsConstants.VIEW_ALL_NETWORKS, communityId: myToolsConstants.ALL_NETWORKS_COMMUNITY_ID });
                    communitiesList.splice(1, 0, { name: myToolsConstants.VIEW_ALL_COMMUNITY_PILOTS, communityId: myToolsConstants.VIEW_ALL_COMMUNITY_PILOTS_ID });
                }
                if (menuType.toLowerCase() === this.menuOptions.FORUM) {
                  communitiesList = [
                    { name: myToolsConstants.FORUM_HUB, communityId: myToolsConstants.FORUM_HUB_ID },
                    { name: myToolsConstants.FORUM_TOOLKIT, communityId: myToolsConstants.FORUM_TOOLKIT_ID },
                      ...communitiesList,
                  ];
                }
                return communitiesList;
            },
            isHivebriteRedirectCommunity(communityId) {
              return !!getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
            },
            navigateToSpecificCommunity(menuOption, communityId) {
              if (menuOption && communityId) {
                if (menuOption.toLowerCase() === this.menuOptions.CHAPTER && communityId === myToolsConstants.CHAPTER_STUDIO_ID) {
                  this.$router.push({
                    path: `/${routerNames.CHAPTER_STUDIO}`,
                  });
                } else if (menuOption.toLowerCase() === this.menuOptions.GROUP && communityId === myToolsConstants.ALL_GROUPS_COMMUNITY_ID) {
                  this.$router.push({
                            path: '/communityDirectoryPage',
                            query: {
                                communityFilters: JSON.stringify(defaultCommunityFilters),
                                communitySearchText: '',
                            },
                  });
                } else if (menuOption.toLowerCase() === this.menuOptions.GROUP && communityId === groupConstants.REQUEST_NEW_GROUP_ID) {
                    this.$refs.requestNewGroupDialog.openNewGroupRequest();
                } else if (menuOption.toLowerCase() === this.menuOptions.NETWORK && communityId === myToolsConstants.ALL_NETWORKS_COMMUNITY_ID) {
                  this.$router.push({
                    path: `/${routerNames.ALL_NETWORKS_PAGE}`,
                  });
                } else if (menuOption.toLowerCase() === this.menuOptions.NETWORK && communityId === myToolsConstants.VIEW_ALL_COMMUNITY_PILOTS_ID) {
                    window.open(myToolsConstants.VIEW_ALL_COMMUNITIES_PILOT_LINK, '_self');
                } else if (menuOption.toLowerCase() === this.menuOptions.FORUM && communityId === myToolsConstants.FORUM_TOOLKIT_ID) {
                  window.open(commonEnvVariables().FORUM_TOOLKIT_DEPARTMENT_PAGE, '_blank');
                } else if (menuOption.toLowerCase() === this.menuOptions.FORUM && communityId === myToolsConstants.FORUM_HUB_ID) {
                  window.open(commonEnvVariables().FORUM_HUB, '_blank');
                } else if (menuOption.toLowerCase() === this.menuOptions.CHAMPION && communityId === myToolsConstants.BECOME_A_CHAMPION_ID) {
                  window.open(commonEnvVariables().BECOME_A_CHAMPION, '_blank');
                } else {
                    const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
                    if (hbRedirectCommunity) {
                      window.open(hbRedirectCommunity.redirectUrl, '_self');
                    } else {
                      this.$router.push(`/${menuOption.toLowerCase()}/${communityId}`);
                    }
                }
              }
          },
            capitalize,
            isSelectedMenuItem(menuItem) {
                return this.$route && this.$route.name && this.$route.name.toLowerCase() === menuItem.toLowerCase();
            },
            isActiveItem(selectedItem) {
                return this.$route && this.$route.params && this.$route.params.communityId &&
                    this.$route.params.communityId === selectedItem.communityId;
            },
            getRibbonNameByMenu(menuItemName) {
                return this.menuDisplayNames.menu.filter(o => o.name.toLowerCase() === menuItemName.toLowerCase())[0].displayName;
            },
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                systemMessages: `notification/${storeGetters.systemMessages}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
                routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                canViewChapterStudioPage: `auth/${storeGetters.canViewChapterStudioPage}`,
            }),
            menuNames() {
                return Object.values(this.menuOptions).map((item) => {
                    return item;
                });
            },
            isMobileSystemMessageVisible() {
              return !this.routeConfigEngagementApp && this.$vuetify.breakpoint.xs;
            },
            welcomeBannerText() {
                const target = this.isMobileAppBrowser ? '_self' : '_blank';
                return getWelcomeBannerText(this.profileInformation, target);
            },
            showNewMemberBannerUI() {
                return showNewMemberBanner(this.profileInformation, this.$route.name);
            },
        },
    };
  </script>

  <style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .system-message-mobile {
        font-size: 13px;
        &--uppercase {
            text-transform: uppercase;
        }
    }

    .nav-menu {
        position: sticky;
        top: 68px;
        z-index: 7;
        color: $ypo-blue;
        background-color: $white;
        box-shadow: 0 0 2px 0 rgba($ypo-gray, 1);
        border-radius: 4px 4px 0 0;
        margin-bottom: 20px;

        @include breakpoint(xs) {
            border-radius: 0;
            margin-bottom: 0;
        }

        &-container {
            .nav-menu__item {
                text-transform: capitalize;
            }
        }

        .v-menu {
            width: 100%;
        }

        .nav-menu__options {

            .v-menu__activator--active {
                background-color: $ypo-blue;

                .nav-menu__item {
                    color: $white;
                }

                i{
                    color: $white !important;
                    opacity: 1;
                }
            }

            &:first-child {
                .nav-menu__item {
                    border-top-left-radius: 4px;
                }
            }

            &:last-child {
                .nav-menu__item {
                    border-top-right-radius: 4px;
                }
            }
        }

        &__item {
            padding: 15px 3px;
            text-align: center;
            width: 100%;
            cursor: pointer;
            text-decoration: none;
            color: $ypo-blue;

          .v-icon {
            color: inherit !important;
          }

            &:hover {
                color: $white;
                background-color: $ypo-blue;
            }
            
            a {
                color: inherit;
                text-decoration: none;
                font-size: 14px;
                font-weight: 300;
                line-height: 16px;
                display: block;
                position: relative;
                transition: 0.3s;
                padding: 18px 0;

                &:first-child {
                    &:before {
                        display: none;
                    }
                }
            }

            .fa-sort-down {
                line-height: normal;
                font-size: 14px;
                position: relative;
                top: -3px;
                padding-left: 5px;
                color: inherit;
                opacity: 0.5;
            }
                       
              }

        &__dropdown {
            will-change: auto;
            contain: inherit;
            max-width: 350px;
            min-width: 200px !important;
            box-shadow: none !important;

            .v-list {
                position: relative;
                padding: 0;
                background-color: $white;
                color: $ypo-blue;
                max-height: 250px;
                overflow: auto;
                border-left: 1px solid rgba($ypo-gray, 0.5);
                border-right: 1px solid rgba($ypo-gray, 0.5);
                border-bottom: 1px solid rgba($ypo-gray, 0.5);

                .v-list__tile {
                    padding-top: 5px;
                    padding-bottom: 5px;
                    height: 35px;

                    &:hover {
                        color: $white;
                        background-color: $ypo-blue;
                    }
                }

                a {
                    text-decoration: none;
                    font-size: 12px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }

        &--active-menu {

            .nav-menu__item {
                color: $white;
                background-color: $ypo-blue;

                .fa-sort-down {
                    opacity: 1;
                }

              .v-icon {
                color: $white;
              }
            }
        }

        &--active-item {
            color: $white;
            background-color: $ypo-blue;
        }

        // Mobile View CSS below

        &--mobile-container {
            position: fixed;
            left: 0;
            top: 50px;
            z-index: 99;
            background: $white;

            &:after {
                left: inherit;
                right: 0;
                background: -webkit-gradient(linear, left top, right top, from(rgba($white, 0.6)), to($white));
            }

            &--bar {
                margin-bottom: 2px;
            }

            .sidebar-tabView__cont {
                padding-bottom: 200px;
            }
        }

        &--mobile-view {
            overflow: auto;
            box-shadow: none !important;
            border-bottom: 1px solid $ypo-medium-gray;
            border-left: 1px solid $ypo-medium-gray;
            background-color: $white;

            &::-webkit-scrollbar {
                display: none;
            }

            .nav-menu {
                &__options {

                    .nav-menu__item {
                        border-radius: 0 !important;
                    }

                    .v-menu__activator--active {

                        .nav-menu__item {
                            background-color: $ypo-cta;
                            color: $white;
                        }

                        i{
                            color: $white !important;
                            opacity: 1;
                        }

                      .v-icon {
                        color: $white;
                      }
                    }
                }

                &__item {
                    padding: 10px 20px;
                    border-right: 1px solid $ypo-medium-gray;
                    text-transform: uppercase;
                    white-space: nowrap;
                    background-color: $white;
                    color: rgba($black, 0.87);
                }

                &--active-menu {
                    .nav-menu__item {
                        background-color: $ypo-cta;
                        color: $white;
                    }
                }
            }
        }

        &--mobile-active-item {
            background-color: $ypo-cta;
            color: $white;
        }

        &__dropdown--mobile {
            max-width: 300px !important;
            min-width: 200px !important;
            z-index: 1000 !important;

            .v-list {
                background-color: $white;
                color: rgba($black, 0.87);;
                width: 100%;
                height: auto;
                padding: 0;
                max-height: 500px;
                overflow: auto;

                .v-list__tile {
                    display: block;
                    padding: 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;

                    &:hover {
                        color: $white;
                        background: rgba($ypo-title-blue, 0.2);
                    }
                }
            }
        }
    }

    .extra-details-menu {
        float: left;
        padding: 15px;
        text-align: center;

        &__result {
            padding: 10px;
            max-height: 650px;
            overflow: auto;
        }

        &--active {
            height: 100%;
            background: rgba($black, 0.2);

            &__icon {
                color: $ypo-cta;
            }
        }
    }

  
</style>

